import React from 'react';
import { MediafileActionButton } from '../MediafileActionButton/MediafileActionButton';
import { DATA_TEST_IDS } from '../consts';
import type { MediafileActionsProps } from './types';
import styles from '../index.module.scss';

export const MediafileActions: React.FC<MediafileActionsProps> = ({ id, actions }) => (
  <div
    className={styles.actions}
    data-testid={DATA_TEST_IDS.ACTIONS(id)}>
    {actions.map((action) => (
      <MediafileActionButton
        key={action.id}
        id={id}
        action={action}
      />
    ))}
  </div>
);
